var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/freezing.js
// module id = dVRt
// module chunks = 0